import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { TID } from "../constants/testIds";
import { Mail, Phone, Instagram, Facebook, MessageCircle } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_performing-arts-ch/artifacts/78ttazwv_400PngdpiLogoCropped.png";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="footer-dark mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <img src={LOGO_URL} alt="KK Academy" className="h-14 w-auto" />
            <div>
              <div className="font-serif-display text-xl text-white">KK Academy</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/60">House of Dance & Music</div>
            </div>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed text-sm">
            {t("hero.sub")}
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://www.instagram.com/kkacademy.ch" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[hsl(var(--brand-gold))] transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://www.facebook.com/share/18YVX38RuW/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[hsl(var(--brand-gold))] transition-colors" aria-label="Facebook">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="mailto:kk@kkacademy.ch" className="text-white/60 hover:text-[hsl(var(--brand-gold))] transition-colors" aria-label="Email">
              <Mail className="w-5 h-5" />
            </a>
            <a href="tel:+41793966660" className="text-white/60 hover:text-[hsl(var(--brand-gold))] transition-colors" aria-label="Phone">
              <Phone className="w-5 h-5" />
            </a>
            <a href="https://wa.me/41793966660?text=Hallo%20KK%20Academy%2C%20ich%20interessiere%20mich%20f%C3%BCr..." target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#25D366] transition-colors" aria-label="WhatsApp">
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--brand-gold))] mb-4">{t("footer.navigation")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/musikakademie" className="text-white/70 hover:text-white">{t("nav.music")}</Link></li>
            <li><Link to="/tanzakademie" className="text-white/70 hover:text-white">{t("nav.dance")}</Link></li>
            <li><Link to="/workshops" className="text-white/70 hover:text-white">{t("nav.workshops")}</Link></li>
            <li><Link to="/events" className="text-white/70 hover:text-white">{t("nav.events")}</Link></li>
            <li><Link to="/galerie" className="text-white/70 hover:text-white">{t("nav.gallery")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--brand-gold))] mb-4">{t("footer.legal")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ueber-uns" className="text-white/70 hover:text-white" data-testid={TID.footerAbout}>{t("footer.about")}</Link></li>
            <li><Link to="/kontakt" className="text-white/70 hover:text-white">{t("nav.contact")}</Link></li>
            <li><Link to="/datenschutz" className="text-white/70 hover:text-white">{t("footer.privacy")}</Link></li>
            <li><Link to="/impressum" className="text-white/70 hover:text-white">{t("footer.imprint")}</Link></li>
            <li><Link to="/admin/login" className="text-white/30 hover:text-white text-xs">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 pb-20 sm:pb-6 text-xs text-white/50 flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left">
          <div className="pl-0 sm:pl-16">© {new Date().getFullYear()} KK Academy. {t("footer.rights")}.</div>
          <div className="flex items-center gap-3 flex-wrap justify-center sm:pr-44">
            <span>Organisator: <span className="text-white/80">Kokilan Kugathasan</span></span>
            <span className="text-white/30 hidden sm:inline">·</span>
            <span>Wil SG · Schweiz</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
